import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { useQuery } from "@tanstack/react-query";
import { TextField } from "@material-ui/core";
import CrearNotibannerIndividual from "../crear-notibanner/crear-notibanner-individual";
import { fetchNotibanner } from "../../../../shared/fetchers/classics/notibanner/verNotibanner";

const EditarNotibanner = () => {
  const [notibanner, setNotibanner] = useState(null);

  const {
    data: notibanners,
    isLoading,
    isError,
  } = useQuery(["notibanner"], fetchNotibanner);

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError)
    return <div>Ha ocurrido un error, prueba recargando la página</div>;

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Editar un notibanner</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <label className="admin-label-text mt-3 d-block">
              Selecciona un notibanner para editarlo
            </label>
            <Autocomplete
              options={notibanners}
              value={notibanner}
              disabled={Boolean(notibanner)}
              getOptionLabel={(notibanner) => {
                let title = "";
                try {
                  title = notibanner?.metadatos?.titulo.es;
                } catch (error) {}

                if (!title) title = "SIN TITULO";

                return `${notibanner.idNotibanner} - ${title}`;
              }}
              onChange={(_, newValue) => {
                setNotibanner(newValue);
              }}
              noOptionsText="Sin resultados"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  style={{
                    width: "100%",
                    fontFamily: "'Noto Sans JP', sans-serif",
                  }}
                />
              )}
            />
          </Col>

          {notibanner && (
            <CrearNotibannerIndividual
              notibanner={{ ...notibanner }}
              clearEdit={() => {
                setNotibanner(null);
              }}
            />
          )}
        </Row>
      </Container>
    </>
  );
};

export default EditarNotibanner;
